import { useContext } from 'react'
import { FilterContext } from 'features/dashboard/filter/FilterContext'
import classNames from 'classnames'
import NoneAnchor from 'components/NoneAnchor'
import { FilterMenus } from 'features/dashboard/filter/FilterSpecs'
import PropTypes from 'prop-types'

const FilterMenu = ({ menu }) => {
  const { selectedMenu, setSelectedMenu } = useContext(FilterContext)
  return (
    <li
      className={classNames({ on: selectedMenu === menu })}
      onMouseEnter={() => setSelectedMenu(menu)}>
      <NoneAnchor
        className={classNames('link_searchfilter', {
          fw_bold: menu === FilterMenus.recent || menu === FilterMenus.saved,
        })}>
        {menu.title} <span className="ico_comm" />
      </NoneAnchor>
    </li>
  )
}
FilterMenu.propTypes = {
  menu: PropTypes.shape({
    title: PropTypes.string,
  }),
}
export default FilterMenu
